import Model, { attr } from '@ember-data/model';
import classic from 'ember-classic-decorator';

@classic
export default class GoodFaithEstimateOverviewModel extends Model {
  @attr('json') allSignatures;
}
